import { useEffect, useRef } from 'react';

// Singleton observer instance shared across all components
let sharedObserver = null;
const observedElements = new Map();

function getSharedObserver() {
    if (!sharedObserver) {
        const options = {
            root: null,
            rootMargin: '200px',
            threshold: 0
        };

        sharedObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const callback = observedElements.get(entry.target);
                if (callback) {
                    callback([entry]);
                }
            });
        }, options);
    }
    return sharedObserver;
}

export function useSharedIntersectionObserver(elementRef, callback) {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const element = elementRef.current;
        if (!element) return;

        const observer = getSharedObserver();

        // Store the callback for this element
        observedElements.set(element, callbackRef.current);

        // Start observing
        observer.observe(element);

        return () => {
            // Stop observing and remove from map
            observer.unobserve(element);
            observedElements.delete(element);
        };
    }, [elementRef]);
}
